export const GLOBAL_CONNECTIONS_CSV_RECEIVED = 'csv_export/GLOBAL_CONNECTIONS_CSV_RECEIVED'
